import AppCard from './AppCard/index';

export default AppCard;
